import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { Avatar } from 'packages/eid-ui'
import { getFullImageUrl } from 'utils'
import { Icon } from 'packages/eid-icons'

export const ApplicationUserCard: FC<any> = ({ data }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                marginRight: '20px',
                marginBottom: '10px',
            }}
        >
            <Box
                sx={{
                    marginRight: '10px',
                }}
            >
                {data.id === '00000000-0000-0000-0000-000000000000' ? (
                    <Icon name="DefaultAvatar" />
                ) : (
                    <Avatar
                        size={'small'}
                        src={getFullImageUrl(data.imageThumbUrl)}
                    />
                )}
            </Box>
            <Box
                sx={{
                    marginBottom: '5px',
                }}
            >
                {data.friendlyName && (
                    <Typography
                        sx={{
                            fontSize: '14px',
                            color: '#5d6870',
                        }}
                    >
                        {data.friendlyName}
                    </Typography>
                )}
            </Box>
        </Box>
    )
}
